import { useGetAllMilestonesQuery } from 'api/siteApi';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isReady } from '../store/bootstrapSlice';
import {
  getSelectedSiteCollaborateInfo,
  getSelectedSiteId,
} from '../store/siteInfoSlice';
import { setBottomBarLoading } from '../store/uiSlice';

export const useBottomBarLoading = () => {
  const dispatch = useDispatch();
  const siteId = useSelector(getSelectedSiteId);
  const bootstrapReady = useSelector(isReady);
  const collaborateInfo = useSelector(getSelectedSiteCollaborateInfo);

  // Get loading states from various hooks
  const { isLoading: isLoadingMilestones, isSuccess: isMilestonesSuccess } =
    useGetAllMilestonesQuery({ siteId: siteId || '' }, { skip: !siteId });

  useEffect(() => {
    // Check if we have a siteId and all data is loaded
    const isBootstrapReady = bootstrapReady === 'success';
    const isBootstrapError = bootstrapReady === 'error';
    const isBootstrapSiteSelection = bootstrapReady === 'site-selection';
    const isBootstrapPluginActivation = bootstrapReady === 'plugin_activation';

    const isSiteReady = !!siteId;
    const isCollaborateInfoReady = !!collaborateInfo;
    const isMilestonesReady = !isLoadingMilestones && isMilestonesSuccess;

    // Hide loading when bootstrap is complete (success or error states)
    // or when all conditions are met for logged-in users
    if (
      isBootstrapError ||
      isBootstrapSiteSelection ||
      isBootstrapPluginActivation ||
      isBootstrapReady ||
      (isSiteReady && isCollaborateInfoReady && isMilestonesReady)
    ) {
      // Add a small delay to ensure UI is fully rendered
      const timer = setTimeout(() => {
        dispatch(setBottomBarLoading(false));
      }, 500);

      return () => clearTimeout(timer);
    } else {
      // Show loading if bootstrap is still loading
      dispatch(setBottomBarLoading(true));
    }
  }, [
    dispatch,
    bootstrapReady,
    siteId,
    collaborateInfo,
    isLoadingMilestones,
    isMilestonesSuccess,
  ]);

  // Reset loading state when siteId changes
  useEffect(() => {
    if (siteId) {
      dispatch(setBottomBarLoading(true));
    }
  }, [dispatch, siteId]);
};
